var HTTP_STATUS_RELOAD = 480;
var HTTP_CONFLICT_STATUS = 409;
var HTTP_FORBIDDEN_STATUS = 403;

export function serializeObjectsForAjax($forms) {
    var o = {};
    $forms.each(function () {
        var $form = $(this);
        $.each($form.serializeArray(), function () {
            var prevObject = o;
            var names = this.name.split('.');

            for (var index = 0; index < names.length - 1; index++) {
                if (!prevObject[names[index]]) {
                    prevObject[names[index]] = {};
                }
                prevObject = prevObject[names[index]];
            }

            var lastName = names[names.length - 1];
            if (prevObject[lastName]) {
                if (!prevObject[lastName].push) {
                    prevObject[lastName] = [prevObject[lastName]];
                }
                prevObject[lastName].push(this.value || '');
            } else {
                prevObject[lastName] = this.value || '';
            }
        });
    });
    return o;
};

export function debounce(func, wait, immediate) {
    var timeout;
    return function () {
        var context = this, args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}


export function getParamFromUrl(param) {
    var results = new RegExp('[\?&]' + param + '=([^&#]*)').exec(window.location.href);
    if (results == null) {
        return null;
    } else {
        return decodeURI(results[1]) || 0;
    }
};

export function redirectIfConflict(jqXHR, reloadOnForbidden) {
    console.error('Ajax error: ' + jqXHR.status);
    if (jqXHR.status === HTTP_CONFLICT_STATUS) {
        const newLocation = jqXHR.getResponseHeader("Location");

        // avoid an infinite redirection loop if an ajax error occurs in the internal server error page and the browser is already there
        if ((typeof inInternalServerErrorPage !== 'undefined' && inInternalServerErrorPage) && (newLocation === '/erreur/500' || newLocation === '/en/error/500')) {
            return false;
        }

        window.location = newLocation;
        return true;
    } else if ((jqXHR.status === HTTP_FORBIDDEN_STATUS && (reloadOnForbidden || reloadOnForbidden === undefined)) || jqXHR.status === HTTP_STATUS_RELOAD) {
        window.location.reload(true);
        return true;
    }
    return false;
};

export function getLocalStorageWithExpiry(key) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) {
        return undefined;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();
    if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return undefined;
    }
    return item.value;
}

export function setLocalStorageWithExpiry(key, value, expiry) {
    const storageValue = {
        value: value,
        expiry: expiry,
    };
    localStorage.setItem(key, JSON.stringify(storageValue));
}